import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useState } from 'react';
import EcommerceImpression from './EcommerceImpression';
import { getListingContactData } from '../../utils/hooks';
import { extractYachtAndContactsFromListingData } from '../../utils/transformers';

const EcommerceImpressionWrapper = ({
  parent: { itemId, itemEntity },
  router,
  id,
  listName,
  promotionType
}) => {
  const { asPath } = router;
  const [currentLocation, setCurrentLocation] = useState('');

  const data = getListingContactData(itemEntity, itemId);
  if (!data) {
    return null;
  }

  const yachtAndContacts = extractYachtAndContactsFromListingData(itemEntity, data, promotionType);
  if (!yachtAndContacts) return null;

  const doesContactMatchPage = !!yachtAndContacts.contacts.find(contact => contact.brokerId === id);

  if (currentLocation !== asPath) {
    setCurrentLocation(asPath);
    return null;
  }

  return (
    <EcommerceImpression
      contacts={
        doesContactMatchPage
          ? yachtAndContacts.contacts.filter(contact => contact.brokerId === id)
          : yachtAndContacts.contacts
      }
      listName={listName}
      currentLocation={currentLocation}
      promotionType={promotionType === 'inherit' ? data.formattedState : promotionType}
      yachtData={yachtAndContacts.yachtData}
    />
  );
};

EcommerceImpressionWrapper.propTypes = {
  id: PropTypes.string,
  router: PropTypes.object.isRequired,
  listName: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  promotionType: PropTypes.string
};

EcommerceImpressionWrapper.defaultProps = {
  id: '',
  promotionType: 'standard'
};

export default withRouter(EcommerceImpressionWrapper);
